export default {
  title: 'Paramètres',
  subscriptionEServiceRateLabel: 'Préférences de communication',
  subscriptionEServiceRateText: ' % en ligne',
  modifybuttonLabel: 'Modifier',
};
